var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoElin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 21 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_649_2210)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.74317 19.8506C7.70165 19.9396 5.50865 20.125 4.12359 18.2785C2.52212 16.1502 4.75841 13.4435 5.87655 11.6044C8.99293 6.60631 6.77107 2.67603 1 1.46729",
    stroke: "#ECA336",
    strokeWidth: 0.26,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8211 12.4423H7.42065V8.47495C7.40516 6.5196 8.14159 4.6371 9.46965 3.23717C10.7977 1.83723 12.6099 1.03318 14.5118 1H20.0016V3.87726C20.002 4.91474 19.8237 5.9441 19.475 6.91767C19.0522 8.04197 18.4116 9.06627 17.5922 9.92841C16.0415 11.478 13.9827 12.3748 11.8211 12.4423Z",
    stroke: "#ECA336",
    strokeWidth: 0.26,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.16797 16.0537C8.03363 15.9943 8.93536 15.9498 9.85873 15.9202C10.7821 15.8905 11.756 15.9202 12.6577 15.9202C12.4918 12.7463 10.0824 12.7092 7.41324 12.4719C7.41324 14.5557 6.56922 16.9213 7.71622 18.8419C8.93536 20.5475 11.9219 20.0062 12.3908 17.9669",
    stroke: "#ECA336",
    strokeWidth: 0.26,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_649_2210"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoElin);
export default __webpack_public_path__ + "static/media/LogoElin.5addccefe531307d67d6fa7c825c538f.svg";
export { ForwardRef as ReactComponent };